<template>
  <div>
    <!-- Swiper -->
    <div class="swiper-container swiper-container2">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="../assets/index/banner1.png" class alt>
        </div>
        <div class="swiper-slide">
          <img src="../assets/index/banner2.png" class alt>
        </div>
        <div class="swiper-slide">
          <img src="../assets/index/banner3.png" class alt>
        </div>
      </div>
    </div>
    <!-- swipter end -->
  </div>
</template>
<script>
import carousel_01 from "../assets/carousel_01.png";
import carousel_02 from "../assets/carousel_02.png";
import carousel_03 from "../assets/carousel_03.png";
import m_carousel_01 from "../assets/m_banner1.png";
import m_carousel_02 from "../assets/m_banner2.png";
import m_carousel_03 from "../assets/m_banner3.png";
import Swiper from "swiper";
var carouselSource = [
  {
    id: 1,
    theme: "嘉信与您一起同行",
    img: carousel_01
  },
  {
    id: 2,
    theme: "保险让生活更美好",
    img: carousel_02
  },
  {
    id: 3,
    theme: "平台更高，视野更广",
    img: carousel_03
  }
];
var carouselSource_m = [
  {
    id: 1,
    theme: "嘉信与您一起同行",
    img: m_carousel_01
  },
  {
    id: 2,
    theme: "保险让生活更美好",
    img: m_carousel_02
  },
  {
    id: 3,
    theme: "平台更高，视野更广",
    img: m_carousel_03
  }
];

export default {
  data() {
    return {
      value2: 0,
      autoplaySpeed: 5000,
      carouselData: []
    };
  },
  mounted() {
    var swiper2 = new Swiper(".swiper-container2", {
      //   pagination: {
      //     el: ".swiper-pagination"
      //   },
      autoplay: {
        disableOnInteraction: false
      },
    //   autoplay: true,
      loop: true
    });
  }
};
</script>
<style scoped lang="less" >
.swiper-slide {
  img {
    display: block;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/swipter.vue